import { FC } from 'react'

export interface HamburgerProps {
  width?: number
  height?: number
}

const Hamburger: FC<HamburgerProps> = ({ width, height }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.5L24 6.5V7.5L0 7.5L0 6.5ZM0 11.5L24 11.5V12.5L0 12.5L0 11.5ZM24 16.5L0 16.5L0 17.5L24 17.5V16.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Hamburger
